import "./sections.css";

import React from "react";

import CardSection from "./CardSection";
import GreekIsles from "./GreekIsles";
import IntroSection from "./IntroSection";
import Nightmares from "./Nightmares";
import PageHero from "./PageHero";
import SpecialNotice from "./SpecialNotice";

const COMPONENTS = {
  hero: PageHero,
  intro: IntroSection,
  cards: CardSection,
  greekIsles: GreekIsles,
  nightmares: Nightmares,
  special: SpecialNotice,
};

//Renders a page's sections from the data in pages.js
const PageSections = ({ sections }) => (
  sections.map((section, i) => {
    const Component = COMPONENTS[section.type];
    return (
      <Component
        key={`${section.type}-${i}`}
        {...section}
      />
    );
  })
);

export default PageSections;
